import React from "react";
import _pubA97D53F3 from "../../../../../../design-system/src/atoms.pc";
import "./styles.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var CleanedFiles = React.memo(React.forwardRef(function CleanedFiles(props, ref) {
  return React.createElement("div", {
    "className": "_c0de277e _dd83f0c9 _pub-dd83f0c9",
    "ref": ref,
  }, 
    props["children"]
  )
}));
export { CleanedFiles };


